var $ = jQuery;

function postComment(formData, opts) {			
	var settings = {
			onComplete:function() {},
			onSuccess:function() {},
			onError:function() {},
			onBeforeSend:function() {}
	};
	
	$.extend(settings, opts);
	
	return $.ajax({
		type:"POST",
		url:JS_VARS.BaseHref + "/VideoController/PostComment",
		data:formData,
		dataType:"json",
		complete:function() {
			settings.onComplete();
		},
		success:function(data) {
			settings.onSuccess(data);
		},
		error:function(a,b,c) {
			settings.onError(a,b,c);
		},
		beforeSend:function() {
			settings.onBeforeSend();
		}
	});
}

function go() {
	$("#CommentPostedNotifier").remove();
	var popup = $('<div id="CommentPostedNotifier"></div>').appendTo("body");
	popup.initMiniDialog({
		width:180
	});
}

module.exports = go;